import { useEffect, useState } from 'react'
import { useGameStore } from '@store/gameStore'
import './TutorialFinale.css'

export function TutorialFinale() {
    const [confettiPieces, setConfettiPieces] = useState<Array<{ id: number; left: number; delay: number; color: string }>>([])
    const completeTutorial = useGameStore(state => state.completeTutorial)
    const addGems = useGameStore(state => state.addGems)

    // Generate confetti on mount
    useEffect(() => {
        const pieces = Array.from({ length: 50 }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 2,
            color: ['#ffd700', '#ff6b6b', '#4ecdc4', '#a855f7', '#3b82f6'][Math.floor(Math.random() * 5)]
        }))
        setConfettiPieces(pieces)
    }, [])

    const handleComplete = () => {
        addGems(100) // Award completion bonus
        completeTutorial()
    }

    return (
        <div className="tut-finale__overlay">
            {/* Confetti */}
            <div className="tut-finale__confetti">
                {confettiPieces.map(piece => (
                    <div
                        key={piece.id}
                        className="tut-finale__confetti-piece"
                        style={{
                            left: `${piece.left}%`,
                            animationDelay: `${piece.delay}s`,
                            backgroundColor: piece.color
                        }}
                    />
                ))}
            </div>

            <div className="tut-finale__modal">
                <h2 className="tut-finale__title">Held, du bist bereit!</h2>

                {/* Reward Section */}
                <div className="tut-finale__reward-section">
                    <div className="tut-finale__reward-badge">
                        🎁 TUTORIAL ABGESCHLOSSEN!
                    </div>
                    <div className="tut-finale__reward-gems">
                        <span className="tut-finale__gems-icon">💎</span>
                        <span className="tut-finale__gems-value">+100</span>
                        <span className="tut-finale__gems-label">Gems</span>
                    </div>
                </div>

                {/* Goal Info */}
                <div className="tut-finale__goal">
                    <p className="tut-finale__goal-text">
                        <strong>Dein Ziel:</strong> Erreiche <span className="tut-finale__highlight">Rang #1</span> im PvP!
                    </p>
                </div>

                <button
                    className="tut-finale__btn"
                    onClick={handleComplete}
                >
                    ABENTEUER STARTEN!
                </button>
            </div>
        </div>
    )
}
